(function () {
  'use strict';
  const language = document.documentElement.lang.split('-')[0];
  const form = document.getElementById('AtelierLanguage');
  form?.addEventListener('submit', function () {
    const target = form.querySelector('[name="return_to"]');
    if (target) target.value = location.pathname + location.search + location.hash;
  });
  // All guided routes concatenate page names onto this root.
  document.querySelectorAll('[data-root]').forEach(function (element) {
    if (element.dataset.root) element.dataset.root = element.dataset.root.replace(/\/?$/, '/');
  });
  if (!['fr', 'de'].includes(language)) return;
  const script = document.querySelector('[data-atelier-localization]');
  if (!script?.dataset.dictionary) return;
  const labels = language === 'fr'
    ? {choose:'Choisissez votre modèle ',search:'Rechercher les modèles ',includes:'Versions incluses : ',model:'modèle',models:'modèles'}
    : {choose:'Wählen Sie Ihr ',search:'Modelle suchen: ',includes:'Einschließlich ',model:'Modell',models:'Modelle'};
  const blocked = 'script,style,template,code,pre,textarea,[data-no-translate]';
  const blockedAttributes = 'script,style,template,code,pre,[data-no-translate]';
  fetch(script.dataset.dictionary).then(function (response) {
    if (!response.ok) throw new Error('Dictionary unavailable');
    return response.json();
  }).then(function (languages) {
    const dictionary = languages;
    function translate(value) {
      const source = value.trim().replace(/\s+/g, ' ');
      if (!source) return value;
      let result = dictionary[source];
      if (!result) {
        const numbered = source.match(/^(\d+\.\s+)(.+)$/);
        if (numbered) {
          const translated = translate(numbered[2]);
          if (translated !== numbered[2]) result = numbered[1] + translated;
        }
        const lookFor = source.match(/^Look for (.+)$/);
        if (lookFor) result = (language === 'fr' ? 'Repérez ' : 'Suchen Sie nach ') + lookFor[1];
      }
      if (!result && /^[←→]/.test(source)) {
        const key = source.replace(/^[←→]\s*/, '');
        if (dictionary[key]) result = source[0] + ' ' + dictionary[key];
      }
      if (!result && /\s[←→]$/.test(source)) {
        const key = source.replace(/\s*[←→]$/, '');
        if (dictionary[key]) result = dictionary[key] + ' ' + source.slice(-1);
      }
      if (!result) {
        let match = source.match(/^Choose your (.+?) model\.?$/);
        if (match) result = language === 'fr' ? labels.choose + match[1] + (source.endsWith('.') ? '.' : '') : labels.choose + match[1] + '-Modell' + (source.endsWith('.') ? '.' : '');
        match = source.match(/^Search (.+?) models$/);
        if (match) result = labels.search + match[1];
        match = source.match(/^Includes (.+)$/);
        if (match) result = labels.includes + match[1];
        match = source.match(/^(\d+) models?$/);
        if (match) result = match[1] + ' ' + (match[1] === '1' ? labels.model : labels.models);
        match = source.match(/^Other (.+?) \/ unsure$/);
        if (match) result = language === 'fr' ? 'Autre ' + match[1] + ' / je ne sais pas' : 'Anderer ' + match[1] + ' / unsicher';
        if (source.includes(' · ')) result = source.split(' · ').map(function (part) { return dictionary[part] || part; }).join(' · ');
      }
      if (!result || result === source) return value;
      return value.replace(value.trim(), result);
    }
    function visit(root) {
      if (root.nodeType === Node.TEXT_NODE) {
        if (!root.parentElement?.closest(blocked)) {
          const next = translate(root.nodeValue);
          if (next !== root.nodeValue) root.nodeValue = next;
        }
        return;
      }
      if (root.nodeType !== Node.ELEMENT_NODE || root.closest(blocked)) return;
      [root, ...root.querySelectorAll('a[href]')].forEach(function (element) {
        if (element.tagName !== 'A') return;
        const href = element.getAttribute('href');
        if (!href || href.startsWith('#') || /^(mailto:|tel:)/i.test(href)) return;
        const url = new URL(href, location.origin);
        if (url.origin !== location.origin || !/^\/(?:pages|products|collections|policies|cart)(?:\/|$)|^\/$/.test(url.pathname)) return;
        url.pathname = '/' + language + (url.pathname === '/' ? '' : url.pathname);
        element.setAttribute('href', url.pathname + url.search + url.hash);
      });
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      const textNodes = [];
      while (walker.nextNode()) textNodes.push(walker.currentNode);
      textNodes.forEach(visit);
      [root, ...root.querySelectorAll('[placeholder],[aria-label],[title]')].forEach(function (element) {
        if (element.closest(blockedAttributes)) return;
        ['placeholder','aria-label','title'].forEach(function (name) {
          if (!element.hasAttribute(name)) return;
          const current = element.getAttribute(name), next = translate(current);
          if (next !== current) element.setAttribute(name, next);
        });
      });
    }
    visit(document.body);
    const titleElement = document.querySelector('title');
    if (titleElement) {
      const translateTitle = function () {
        const current = document.title;
        const next = current.split(' · ').map(translate).join(' · ');
        if (next !== current) document.title = next;
      };
      translateTitle();
      new MutationObserver(translateTitle).observe(titleElement, {childList:true,characterData:true,subtree:true});
    }
    const pending = new Set(); let scheduled = false;
    const observer = new MutationObserver(function (records) {
      records.forEach(function (record) {
        if (record.type === 'characterData') pending.add(record.target);
        else record.addedNodes.forEach(function (node) { pending.add(node); });
      });
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        const nodes = [...pending]; pending.clear();
        nodes.filter(function (node) { return node.isConnected; }).forEach(visit);
      });
    });
    observer.observe(document.body, {childList:true,subtree:true,characterData:true});
  }).catch(function () { /* The native locale text remains usable if the optional dictionary fails. */ });
})();
